
<sm-title-bar pageTitle="{{ 'support_ticket_details.title' | translate }}" [backWithParams]="true" >

<!--   
    <ng-template #addButton>
      <div class="d-flex search-field">
        <button mat-flat-button color="accent">
          Raise New Query
          <mat-icon class="material-icons-round" [inline]="true"
            >add_circle</mat-icon
          >
        </button>
       
      </div>
    </ng-template> -->
  
  </sm-title-bar>
  <div class="cont" *ngIf="supportTicketDetails.length > 0 && !loader">
    <div class="ticket-header row">
        <div class="col-md-9">
            <h3 style="margin-bottom: 5px;">{{selectedTicket.subject}}</h3>
            <span class="ticket-id">{{ selectedTicket.creation_time | date : 'MMMM d, y, h:mm a' }}</span>
            <div class="status_open" [ngStyle]="{'background-color': selectedTicket.resolve_status == 1 ? '#0768be' : (selectedTicket.resolve_status == 0 ? 'green' : (selectedTicket.resolve_status == 2 ? '#ffaf17' : (selectedTicket.resolve_status == 3 ? 'red' : ''))) }">{{selectedTicket.resolve_status == 1 ? 'RESOLVED' : (selectedTicket.resolve_status == 0 ? 'OPEN' : (selectedTicket.resolve_status == 2 ? 'IN-PROGRESS' : (selectedTicket.resolve_status == 3 ? 'CLOSED' : '')))}}</div>
        </div>
        <div class="col-md-3" style="text-align: right;">
        <div class="suppor_sert">
          <button  mat-button aria-label="option menu"
          [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
              </button>
            </div>                       
              <mat-menu #menu="matMenu">
                  <button  mat-menu-item *ngIf="selectedTicket.resolve_status != 1" (click)="setserviceStatus(1)">
                    <mat-icon class="material-icons-outlined">task_alt</mat-icon>
                    <span>{{ 'support_ticket_details.op1' | translate }}</span>
                  </button>
                  <button  mat-menu-item *ngIf="selectedTicket.resolve_status != 0" (click)="setserviceStatus(0)">
                    <mat-icon class="material-icons-outlined">import_contacts</mat-icon>
                    <span>{{ 'support_ticket_details.op2' | translate }}</span>
                  </button>
                  <button  mat-menu-item *ngIf="selectedTicket.resolve_status != 2" (click)="setserviceStatus(2)">
                    <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
                    <span>{{ 'support_ticket_details.op3' | translate }}</span>
                  </button>
                  <button  mat-menu-item *ngIf="selectedTicket.resolve_status != 3" (click)="setserviceStatus(3)">
                    <mat-icon class="material-icons-outlined">block</mat-icon>
                    <span>{{ 'support_ticket_details.op4' | translate }}</span>
                  </button>
                  <button  mat-menu-item  (click)="setserviceStatus(6)">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>{{ 'support_ticket_details.op5' | translate }}</span>
                  </button>
                 
                </mat-menu>
        </div>
       
    </div>
    <div class="message" *ngFor="let item of supportTicketDetails">
        <div class="col-sm-2">
          <div class="user-info">
            <div class="prn_headingt">
            <img [src]="item.user_image" onerror="this.src='../../../../assets/images/user-avatar.svg'" alt="Company Logo" class="avatar">
          </div>
          <div class="itr_headingt">
            <p class="username"> {{item.name}} </p>
            <p class="onwer_jher">{{item.creator_type == 1 ? 'Owner' : 'Support staff' }}</p>
          </div>
          </div>
        </div>
        <div class="message-content col-sm-10" >
            <p> {{item.description}} </p>
            <div class="attachments">
                <span class="attachment" *ngFor="let element of item.uploads"> 
                  <a [href]="element.img_url" target="_blank"><mat-icon class="attg">attach_file</mat-icon> {{extractFileName(element.img_url)}}</a> 
                 </span>
                <!-- <span class="attachment">rp-error.png</span>
                <span class="attachment">rp-website-details.png</span>
                <span class="attachment">rp-website-details.png</span>
                <span class="attachment">rp-company-name.png</span> -->
            </div>
        </div>
        <span class="time-stamp"> {{item.creation_time | date : 'MMMM d, y, h:mm a'}} </span>
    </div>
    <!-- <div class="message">
        <div class="user-info col-md-2">
            <img src="https://png.pngtree.com/png-vector/20221125/ourmid/pngtree-host-and-admin-marketing-job-vacancies-vector-png-image_6480101.png" alt="Razorpay Logo" class="avatar">
            <span class="username">Admin Support</span>
        </div>
        <div class="message-content col-md-10">
            <p>Dear Partner,</p>
            <p>Greetings for the day!</p>
            <p>This is to acknowledge that we have received your request and it is being tracked with reference number ABCD.</p>
           
        </div>
        <span class="time-stamp">3 months ago</span>
    </div> -->

    <div class="reply_btnyh">
      <button (click)="sendSupportQueryResponse()"
      mat-stroked-button><mat-icon style="position: relative; top: -2px">reply</mat-icon>
      {{ 'support_ticket_details.reply' | translate }}
    </button>
      </div>
</div>
<mat-paginator
*ngIf="!loader"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>